import { Space, Tabs, Row, Col } from "antd";
import React from "react";
import Box from "../../../../../components/Box/Box";
import SummaryCard from "./SummaryCard";
import { CalendarTwoTone } from '@ant-design/icons';

const PayGroupSummary = () => {
    const PayCycleData = {
        heading: {
            name: 'Pay Cycle',
            description: 'Running payroll on accelgrowth since october 2021',
            icon: <CalendarTwoTone />
        },
        data: [
            {
                name: 'Pay period end date',
                value: 12,
                status: true
            },
            {
                name: 'Weekly offs are paid',
                value: 'No',
                status: false
            },
            {
                name: 'Holidays are paid',
                value: 'No',
                status: false
            },
            {
                name: 'Monthly payment',
                value: 'Enabled',
                status: true
            }, {
                name: 'Daily payment',
                value: 'Enabled',
                status: true
            }
        ]
    }

    const ContributionData = {
        heading: {
            name: 'Contributions',
            description: 'Running payroll on accelgrowth since october 2021',
            icon: <CalendarTwoTone />
        },
        data: [
            {
                name: 'Provident Fund (PF)',
                value: 'Yes',
                status: true
            },
            {
                name: 'Employee State Insurance (ESI)',
                value: 'Enabled',
                status: true
            },
            {
                name: 'Labor Welfare Fund (LWF)',
                value: 'No',
                status: false
            },
            {
                name: 'Monthly payment',
                value: 'Enabled',
                status: true
            }, {
                name: 'Daily payment',
                value: 'Enabled',
                status: true
            }
        ]
    }

    const SalaryComponentsData = {
        heading: {
            name: 'Salary Components',
            description: 'Running payroll on accelgrowth since october 2021',
            icon: <CalendarTwoTone />
        },
        data: [
            {
                name: 'Range based Structure',
                value: 'Configured',
                status: true
            },
            {
                name: 'Custom structure',
                value: 'Configured',
                status: true
            }
        ]
    }

    const TaxesDeductionsData = {
        heading: {
            name: 'Taxes & Deductions',
            description: 'Running payroll on accelgrowth since october 2021',
            icon: <CalendarTwoTone />
        },
        data: [
            {
                name: 'Income Tax (IT) Declarations',
                value: 'Not Configured',
                status: false
            },
            {
                name: 'Allowance change in tax regime',
                value: 'Enabled',
                status: true
            },
            {
                name: 'Professional tax',
                value: 'No',
                status: false
            },
        ]
    }

    const FillingDetails = {
        heading: {
            name: 'Filling Details',
            description: 'Running payroll on accelgrowth since october 2021',
            icon: <CalendarTwoTone />
        },
        data: [
            {
                name: 'Income Tax (IT)',
                value: 12,
                status: true
            },
            {
                name: 'Provident Fund',
                value: 'No',
                status: false
            },
            {
                name: 'Professional Tax',
                value: 'No',
                status: false
            },
        ]
    }

    return <>
        <Space direction="vertical" style={{ width: '100%' }}>
            <Row gutter={[16, 16]}>
                <Col span={12}>
                    <Box title={PayCycleData.heading.name}>
                        <SummaryCard data={PayCycleData} />
                    </Box>
                </Col>
                <Col span={12}>
                    <Box title={ContributionData.heading.name}>
                        <SummaryCard data={ContributionData} />
                    </Box>
                </Col>
                <Col span={12}>
                    <Box title={SalaryComponentsData.heading.name}>
                        <SummaryCard data={SalaryComponentsData} />
                    </Box>
                </Col>
                <Col span={12}>
                    <Box title={TaxesDeductionsData.heading.name}>
                        <SummaryCard data={TaxesDeductionsData} />
                    </Box>
                </Col>
                <Col span={12}>
                    <Box title={FillingDetails.heading.name}>
                        <SummaryCard data={FillingDetails} />
                    </Box>
                </Col>
            </Row>
        </Space >
    </>

}

export default PayGroupSummary;